import { styles, apiKey } from './settings'
import loadGoogleAPI from 'load-google-maps-api'
import lozad from 'lozad'

async function createMap(mapElement, locations, zoom = 0, enableLegend = 0) {
  lozad(mapElement, {
    rootMargin:'0px',
    threshold:0.5,
    async load(el) {
      const googleApi = await loadGoogleAPI({
        key: apiKey,
        language: 'en'
      })
      const bounds = new googleApi.LatLngBounds()
      const map = new googleApi.Map(el, {
        zoom,
        center: locations[0],
        styles: styles,
        disableDefaultUI: true
      })
      let activeInfoWindow = null;
      locations.forEach(location => {
        const url = {
          url: location.marker,
          scaledSize: new google.maps.Size(25, 25), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(0, 0) // anchor
        }
        const marker = new google.maps.Marker({
          position: location,
          icon: url,
          url: location.url,
          optimized: false,
          map
        })
        if(location.name && location.name != ''){
          const infowindow = new google.maps.InfoWindow({
            content: location.name,
          })
          marker.addListener('click', () => {
            activeInfoWindow&&activeInfoWindow.close();
            infowindow.open({
              anchor: marker,
              map,
              shouldFocus: false,
            });
            activeInfoWindow = infowindow;
          })
        }
        if (location.url) {
          marker.addListener('click', () => {
            window.open(marker.url, '_blank')
          })
        }
      })
      if(enableLegend){
        const legend = document.getElementById('areas-legend')
        if(legend){
          map.controls[google.maps.ControlPosition.RIGHT_TOP].push(legend)
        }
      }
      if (locations.length > 1) {
        locations.forEach(location => bounds.extend(location))
        map.fitBounds(bounds)
      }
    }
  }).observe()
}
export { createMap }
